import React from 'react';
import classNames from 'classnames';

import SpotDetails from 'components/SpotDetails';
import SpotThumbnail from 'components/SpotThumbnail';
import SpotListCTAThumbnail from 'components/SpotListCTAThumbnail';
import type { SpotTravel } from 'types/spot';
import type { Units } from 'types/units';

import styles from './SpotListItem.module.scss';

interface SpotListItemProps {
  spot: SpotTravel;
  units: Units;
  showPremiumCamCTA?: boolean;
  mobileCard?: boolean;
}

const getBackgroundImg = (spot: SpotTravel) => spot?.cameras?.[0]?.stillUrl ?? spot?.thumbnail;

const getClassName = (mobileCard: boolean) =>
  classNames({
    'quiver-spot-list-item__container': true,
    'quiver-spot-list-item__container--mobile-card': mobileCard,
  });

const SpotListItem: React.FC<SpotListItemProps> = ({
  spot,
  units,
  showPremiumCamCTA = false,
  mobileCard = false,
}) => (
  <div className={getClassName(mobileCard)}>
    <div
      className={classNames(styles.spotListItem, 'quiver-spot-list-item')}
      style={{ backgroundImage: `url('${getBackgroundImg(spot)}')` }}
    >
      <div className="quiver-spot-list-item__container">
        {showPremiumCamCTA ? (
          <SpotListCTAThumbnail spot={spot} />
        ) : (
          <SpotThumbnail
            windDirection={spot.wind.direction}
            windSpeed={spot.wind.speed}
            units={units}
            hasCamera={spot.cameras.length > 0}
          />
        )}
        <SpotDetails showPremiumCamCTA={showPremiumCamCTA} spot={spot} units={units} />
      </div>
    </div>
  </div>
);

export default SpotListItem;
